import _ from 'lodash'

const DefaultValidator = ({type})=>{ 

        let errors = {};
        if (_.isEmpty(type)) {
            errors.type = "Please choose level-type.";
        }        
  
        return errors;

}

export default DefaultValidator;